import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { DealForecastStateMode } from '@openx/types/dealForecasting.ts';
import type { ConstValues } from '@openx/types/helpers.ts';
import i18n from 'i18next';

import { SystemAlertIcon } from './components/SystemAlertIcon.tsx';

export const forecastStateData = {
  [DealForecastStateMode.Error]: {
    IconComponent: SystemAlertIcon,
    heading: (isTimeoutError: boolean): string =>
      i18n.t(
        isTimeoutError
          ? 'The request timeout limit has been exceeded.'
          : 'Oops! Something went wrong while generating a forecast.'
      ),
    subtitle: (): string => i18n.t('Please try again later or contact support for assistance.'),
    traceIdText: (trace_id: string): string => i18n.t('Trace ID: {trace_id}', { trace_id }),
  },
  [DealForecastStateMode.Loading]: {
    IconComponent: Loader,
    heading: (): string => i18n.t('Retrieving data'),
    subtitle: (): string => i18n.t('Please wait while your Deal Plan is generated.'),
  },
  [DealForecastStateMode.No_Data]: {
    IconComponent: null,
    heading: (): string => i18n.t('No data'),
    subtitle: (isOa: boolean): string =>
      i18n.t(
        isOa
          ? 'To generate a Deal Plan, you must select a DSP and a set of targeting.'
          : 'To generate a Deal Plan, you must select a DSP, a set of targeting and your deal must be Within Open Auction.'
      ),
  },
  [DealForecastStateMode.All_Set]: {
    IconComponent: SystemAlertIcon,
    heading: (): string => i18n.t('All set'),
    subtitle: (): string =>
      i18n.t('All required parameters to generate the plan have been set. Now, you need to press the generate button.'),
  },
};

export const TopMarketRequestsType = {
  DOMAINS: 'domains',
  BUNDLES: 'bundles',
} as const;
export type TopMarketRequestsType = ConstValues<typeof TopMarketRequestsType>;
